import { render, staticRenderFns } from "./RegisterModuleBasic.vue?vue&type=template&id=c4705728&scoped=true&"
import script from "./RegisterModuleBasic.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleBasic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModuleBasic.vue?vue&type=style&index=0&id=c4705728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4705728",
  null
  
)

export default component.exports